<template>
    <div class="sport">
        <bk-frame
            :settings="settings"
            :onOrderDisplay="handleOnOrderDisplay"
            :onOrderEnabled="handleOnOrderEnabled"
            :onOrdered="handleOnOrdered" />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import BkFrame from '../../../../_common/components/bk-frame.vue';
    import { sync } from 'vuex-pathify';
    import { printHtml } from '../../services/device.service';
    import NavigationButton from '../../components/button/africa/navigation-button.vue';

    export default {
        name: 'sport',
        components: { BkFrame, NavigationButton },
        computed: {
            ...sync('settings/persistent@', ['topTitle']),
            settings () {
                return {
                    theme: 'xplay-kiosk',
                    bet: 'cashbox',
                    kiosk: 0,
                    keyboard: 1,
                    rprefix: '/sport',
                    route: this.$route.fullPath === '/sport' ? '/sport/prematch' : this.$route.fullPath,
                    fsize: '16px',
                    logo: `${window.location.origin}/static/theme/africa/janta-bets-logox2.png`,
                    back: `${window.location.origin}/menu`,
                    desktopMenuMainVerticalPopular: 0,
                    desktopMenuMainVerticalLive: 0,
                    basketOptions: 0,
                    basketOrderNotice: 0,
                }
            },
        },
        methods: {
            ...mapActions({
                reservationSetNumber: 'reservation/setNumber',
            }),
            async printOrderNumber(number) {
                let html = '<html>';
                html += '<head><style>h3 {text-align: center;}</style></head>';
                html += '<body>';
                html += '<h3>Use the booking code</h3>';
                html += '<h3>to pay your bet</h3>';
                html += '<h3>at the cashier</h3>';
                html += `<h3>${number}</h3>`;
                html += '<h3>****</h3>';
                html += '</body>';
                html += '</html>';
                var res = await printHtml(html);
            },
            async handleOnOrdered(event) {
                this.printOrderNumber(event.detail.number);
                this.reservationSetNumber(event.detail.number);
                this.$router.push('#reservation');
            }
        },
        mounted() {
            this.topTitle = 'Sports';
        }
    };
</script>

<style lang="scss">
    // .sport {
    //     flex: 1 1 100%;
    //     height: 100%
    // }
    // .sport .bk-frame {
    //     min-height: 100vh;
    // }
    .sport {
        flex: 1 1 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    
</style>


// WEBPACK FOOTER //
// front/src/skins/xkiosk/pages/sport/sport.vue